import React, { useState } from 'react'
import styled from 'styled-components'
import { LoggedUserMenu } from './LoggedUserLinks'
import { MainMenu } from './MainMenu'
import { Menu } from './Menu'
import { MenuButtons, MenuGrid, useHeaderInit } from './platform'
import { MenuContainer } from './MenuContainer'
import { MenuLogo } from './Logo'
import { MobileMenuFooter } from './MobileMenuFooter'
import { Overlay } from './Overlay'
import { ToggleMenu, ToggleMenuCheckbox } from './Toggles'
import { buildMenu } from './utils'
import { menuList } from './menuList'
import {
  useDisableBodyScroll,
  useLoggedUsername,
  useMenuVisible
} from './hooks'

const Main = styled((props: any) => <div {...props}>{props.children}</div>)`
  background-color: white;
  left: 0;
  top: 0;
  position: fixed;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 101;
  height: 80px;
  transition-duration: 0.4s;
  ${(props) => !props.visible && 'transform: translateY(-80px);'}
`

const ContentSpacer = styled.div`
  height: 80px;
`

type HeaderProps = {
  hideFindPsychologistButton?: boolean;
};

const Header: React.FC = (props: HeaderProps) => {
  useHeaderInit()
  const topMenu = buildMenu(menuList)
  const [isExpanded, setExpanded] = useState(false)

  useDisableBodyScroll(isExpanded)
  const visible = useMenuVisible()
  const username = useLoggedUsername()

  return (
    <>
      <ContentSpacer />
      <Overlay isExpanded={isExpanded} onClick={() => setExpanded(false)} />
      <Main visible={visible}>
        <MenuGrid>
          <Menu>
            <MenuLogo />
            <ToggleMenu onChange={setExpanded} value={isExpanded} />
            <ToggleMenuCheckbox checked={isExpanded} />
            <MainMenu username={username}>
              <MenuContainer>
                {topMenu}
                {username && <LoggedUserMenu username={username} />}
              </MenuContainer>
              <MobileMenuFooter />
            </MainMenu>
            {
              !username &&
              <MenuButtons
                hideFindPsychologistButton={props.hideFindPsychologistButton}
              />
            }
          </Menu>
        </MenuGrid>
      </Main>
    </>
  )
}

export default Header;